import React from 'react'
import Footer from './Footer'
import { Outlet } from 'react-router-dom';
import HeaderFaculty from './HeaderFaculty';

export default function OutletRouteSchool() {
  return (
    <>
      <HeaderFaculty />
      <Outlet />
      <Footer />
    </>
  )
}
